/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { Observable } from 'rxjs/Observable';

import { UserService } from '../../services/user.service';
import { AccountService } from '../../services/account.service';
import { SkuService } from '../../services/sku.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';
import { EmailDetailService } from '../../services/email-detail.service';
import { AggregateService } from '../../services/aggregate.service';
import { AuthService } from '../../services/auth.service';
import { ErrorService } from '../../services/error.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { DriftService } from '../../services/drift.service';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-settings-subscription',
  templateUrl: './settings-subscription.component.html'
})
export class SettingsSubscriptionComponent implements OnInit {

  loadingPage: boolean = true;
  session: any;
  profile: any = {};
  account: any = {};
  skus: any[] = [];
  editions: any[] = [];
  invoices: any[] = [];
  summaryData: any = {};
  rollingAvg: number = 0;

  // form values
  paymentFrequency: any[] = [
    { name: 'Annually'},
    { name: 'Monthly' }
  ];

  paymentMethod: any[] = [
    { name: 'Invoice' }
  ];

  replyLimits: any[] = [];

  inTrial: boolean = false;
  activate: boolean = false;
  terms: boolean = true;
  selectedEdition: any = null;
  selectedPaymentFreq: any = {};
  selectedPaymentMethod: any = {};
  validCC: boolean = false;
  priceOverride: number = 0;

  selectedInvoice: any = {};

  canBuy: boolean = false;
  termsAccepted: boolean = false;
  currentUserId: string;

  constructor(private userService: UserService,
              private accountService: AccountService,
              private skuService: SkuService,
              private cacheService: CacheService,
              private sessionService: SessionService,
              private emailDetailService: EmailDetailService,
              private aggregateService: AggregateService,
              private authService: AuthService,
              private errorService: ErrorService,
              private globalMessageService: GlobalMessageService,
              private modalService: BsModalService,
              private driftService: DriftService) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  editionChange() {
  }

  async saveEdition() {
    var update = {
      terms_accepted: {
        accepted_date: new Date(),
        accepted_user_id: this.currentUserId
      },
      'subscription.start_date': new Date()
    };

    this.accountService.updateAccountSubscription(update).subscribe(
      (result: any) => {
        this.globalMessageService.message('Edition details saved');
        this.activate = false;
        this.inTrial = false;
        this.termsAccepted = true;
        this.initView();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'settings-subscription.component', 'saveEdition');
      }
    )
  }

  async agreeTerms() {
    var update = {
      terms_accepted: {
        accepted_date: new Date(),
        accepted_user_id: this.currentUserId
      }
    };

    this.accountService.updateAccountSubscription(update).subscribe(
      (result: any) => {
        this.globalMessageService.message('Edition details saved');
        this.initView();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'settings-subscription.component', 'saveEdition');
      }
    )
  }

  displayInvoice(dialog, invoice) {
    this.selectedInvoice = invoice;
    this.modalService.show(dialog, {class: 'modal-md'});
  }

  private async initView() {
    this.loadingPage = true;
    this.editions = [];

    this.currentUserId = await this.authService.getCurrentUserId()

    Observable.forkJoin(
      this.accountService.getAccountSubscription(),
      this.skuService.getSkus(),
      this.userService.getProfile(),
      this.emailDetailService.atLeastOne('')
    ).subscribe(
      (result: any) => {
        this.account = result[0];
        this.skus = result[1];
        this.profile = result[2];
        let endDT = new Date();
        let startDT = new Date();
        // need to calculate rolling 90-day average based on first email received to avoid skewing the result
        if (result[3].has_one) {
          this.aggregateService.getSummary(startDT, endDT).subscribe(
            (result: any) => {
              // for rolling avg we need to cover cases where an account hasn't been around for 90 days
              let numDays = 90;
              startDT.setDate(startDT.getDate() - numDays);
              let firstEmailDT = new Date(result.human_trend[0].date);
              let dDiff = (firstEmailDT.getTime() - startDT.getTime())/(1000*60*60*24);
              if (dDiff > 1) {
                numDays = 90 - Math.floor(dDiff);
              }
              this.summaryData = result;
              this.rollingAvg = (result.total_emails / numDays) * 30;
            },
            error => {

            }
          )
        }

        this.skus.forEach((sku) => {
          if (sku._id == this.account.subscription.sku_id) {
            this.account.sku = sku;
            if (sku.name != "Complimentary" && sku.name != "Free Trial") {
            }
            else {
              this.inTrial = true;
            }
          }

          if (sku.active && sku.reply_limit && sku.reply_limit > 0) {
            for (var idx=0, rl=sku.reply_limit; rl<= sku.max_replies; idx++, rl+=sku.reply_jump) {
              this.editions.push({
                sku_id: sku._id,
                sku_name: sku.name,
                limit: rl,
                price: sku.price + (sku.price_jump * idx)
              });

              if (sku._id == this.account.subscription.sku_id && rl == this.account.subscription.reply_limit) {
                this.selectedEdition = this.editions[this.editions.length-1];
              }
            }
          }
        });

        this.paymentFrequency.forEach((pf) => {
          if (pf.name == this.account.billing.payment_frequency) {
            this.selectedPaymentFreq = pf;
          }
        });

        this.paymentMethod.forEach((pm) => {
          if (pm.name == this.account.billing.payment_method) {
            this.selectedPaymentMethod = pm;
          }
        });

        if (!this.selectedEdition) {
          this.selectedEdition = this.editions[0];
        }

        this.editionChange();

        if (!this.account.billing.payment_frequency || this.account.billing.payment_frequency=='n/a') {
          this.selectedPaymentFreq = this.paymentFrequency[0];
        }

        if (this.account.billing.credit_card && this.account.billing.credit_card.card) {
          this.validCC = true;
        }

        if (this.account.billing.price > 0) {
          this.canBuy = true;
        }

        if (this.account.terms_accepted && this.account.terms_accepted.accepted_date) {
          this.activate = true;
        }

        // check for discount override (admin set terms)
        if (this.account.billing.coupon && this.account.billing.coupon.id && this.account.billing.coupon.id.length > 0) {
          var amount = this.account.billing.price;
          if (this.account.billing.payment_frequency == "Annually") {
            amount *= 12;
          }

          if (this.account.billing.coupon.percent_off > 0) {
            this.priceOverride = amount * ((100-this.account.billing.coupon.percent_off)/100);
          }
          else {
            this.priceOverride = amount - (this.account.billing.coupon.amount_off/100);
          }
        }

        this.invoices.forEach((invoice) => {
          invoice.viewDate = new Date(invoice.date*1000);
          invoice.periodStartDate = new Date(invoice.period_start*1000);
          invoice.periodEndDate = new Date(invoice.period_end*1000);
          if (invoice.discount && invoice.discount.coupon) {
            if (invoice.discount.coupon.percent_off) {
              invoice.discountAmount = invoice.lines.data[0].amount/100*(invoice.discount.coupon.percent_off/100);
              invoice.subTotalBeforeTax = invoice.lines.data[0].amount - invoice.discountAmount;
            }
            else {
              invoice.discountAmount = invoice.discount.coupon.amount_off/100;
              invoice.subTotalBeforeTax = invoice.lines.data[0].amount - invoice.discountAmount;
            }
          }
        });

        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'settings-subscription.component', 'initView');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/settings/settings-subscription/settings-subscription.component.ts